export default __webpack_public_path__ + "static/linkindin-meta-586ca324a3b843730645623169fcb055.png";